import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Range } from 'src/app/models/configurators-2d/applications/closet-doors-standard/range';
import { ClosetDoorsStandardService } from 'src/app/services/configurators-2d/applications/closet-doors-standard.service';

@Component({
  selector: 'ng-closet-doors-standard-range',
  templateUrl: './range.component.html',
  styleUrls: ['./range.component.scss'],
})
export class ClosetDoorsStandardRangeComponent implements OnInit {
  /** Identifiant de la configuration courante (nécessaire pour filtrer les gammes compatibles) */
  @Input() configId: string;

  /** Gamme actuellement sélectionnée */
  @Input() selectedRange: Range | null;

  /** Émis lors de la sélection d'une gamme */
  @Output() onRangeSelect = new EventEmitter<Range>();

  ranges: Range[] | null = null;

  baseImgURL: string;

  constructor(private closetDoorsService: ClosetDoorsStandardService) {
    this.baseImgURL = this.closetDoorsService.apiUrl;
  }

  ngOnInit(): void {
    this.closetDoorsService.getRanges(this.configId).then((ranges: Range[]) => {
      this.ranges = ranges;

      if (this.selectedRange) {
        // Un rangeId a été restauré depuis le projet sauvegardé.
        // On remplace l'objet minimal par la version complète de la liste.
        const saved = ranges.find(r => r.id === this.selectedRange.id);
        if (saved) {
          this.selectRange(saved);
          return;
        }
      }

      // Aucune gamme sauvegardée ou gamme introuvable dans la liste : pré-sélection de la première.
      if (this.ranges.length > 0) {
        this.selectRange(this.ranges[0]);
      }
    });
  }

  /** Sélectionne une gamme et notifie le parent */
  selectRange(range: Range): void {
    this.onRangeSelect.emit(range);
  }

  /** Indique si une gamme est la gamme couramment sélectionnée */
  isRangeSelected(id: number): boolean {
    return this.selectedRange?.id === id;
  }
}
